export default __webpack_public_path__ + "static/media/hht2_storybook_10.6130363a.png";